import { PropsWithChildren } from 'react';
import Button from '../Button';
import Div from '../Div';
import { CouponItem } from '@/components/Product/AddToCart';
import Paragraph from '../Paragraph';
import { useEcomProductContext } from '@/context/ecomProductContext';
import { EcomGTMEventNames } from '@/types/ecomGTM';
import useEcomGTM from '@/hooks/useEcomGTM';

export interface FeaturedCouponProps {
  featuredCoupon?: CouponItem;
}

const FeaturedCoupon = (props: PropsWithChildren<FeaturedCouponProps>) => {
  const { featuredCoupon } = props;
  const { dispatch: ecomProductDispatch, state: ecomProductState } = useEcomProductContext();
  const { materialId } = ecomProductState.currentProduct;
  const { fireEcomGTMEvent } = useEcomGTM();

  const applyCoupon = () => {
    ecomProductDispatch.updateAppliedCoupon({
      materialId: materialId,
      appliedCoupon: featuredCoupon,
    });
    fireEcomGTMEvent(EcomGTMEventNames.PDP.COUPON_APPLY_STARTED, {
      selected_coupon_name: featuredCoupon?.coupon,
      selected_coupon_value: featuredCoupon?.applicableDisc,
      selected_coupon_validity: featuredCoupon?.expiry,
    });
  };

  return featuredCoupon ? (
    <Div className="flex p-s4 gap-s3 border-solid rounded-cxs justify-between items-center mt-s4 bg-gradient-to-b from-[#E0F4EC] to-[#E0F4EC] bg-opacity-50">
      <Paragraph className="text-body-base lg:body-lg">
        <b>{`Save ₹${featuredCoupon?.applicableDisc}`}</b>
        {` with coupon ‘${featuredCoupon?.coupon}’`}
      </Paragraph>
      <Button type="button" theme="link" size="sm" className="!p-0" onClick={applyCoupon}>
        Apply
      </Button>
    </Div>
  ) : null;
};

export default FeaturedCoupon;
